<template>
    <SuperSpinContainer />
</template>

<script>
    import SuperSpinContainer from '@modules/superSpin/SuperSpinContainer';

    export default {
        name: 'SuperSpinPage',
        components: {
            SuperSpinContainer,
        },
    };
</script>
